import styled from 'styled-components';

export const StyledTabSideMenuConfiguration = styled.div`
    display: flex;
    place-content: center;
`;
